module.exports = __webpack_public_path__ + "assets/img/vue_starter_node_modules.e5a3966c.jpg";